'use strict';

class UserPasswordService {
  constructor($resource) {
    'ngInject';
    this.api = $resource(
      '/auth_api/end_user_password',
      {},
      {
        create: { method: 'POST', isArray: false }
      }
    );

    this.oem_api = $resource(
      '/auth_api/oem_user_password',
      {},
      {
        create: { method: 'POST', isArray: false }
      }
    );
  }
}

export default angular.module('leptonApp.UserPasswordService', ['ngResource'])
  .service('UserPasswordService', ['$resource', UserPasswordService])
  .name;



// WEBPACK FOOTER //
// ./public/dev/components/api/user_password/user_password.service.js